<template>
  <input
    type="file"
    style="display:none;"
    v-bind="attributes"
    @change="onChange"
  />
</template>

<script>
import {
  IS_CAPTURE_SUPPORTED,
  ERROR_FILE_TOO_BIG,
  ERROR_FILE_FORMAT,
  ERROR_TOO_MANY_FILES,
} from './consts'

export default {

  emits: [
    'error',
    'input',
  ],
  name: 'b-upload',

  props: {

    accept: {
      type: String,
      default: '*/*',
    },

    capture: {
      type: [Boolean, String],
      default: false,
    },

    fileTypeRegex: {
      type: RegExp,
      required: false,
    },

    size: {
      type: Number,
      default: 10,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    maxLengthOfFiles: {
      type: Number,
      default: 6,
    },

  },

  computed: {

    maxSize () {
      return 1024 * 1024 * this.size
    },

    useCapture () {
      // shortcut
      if (!this.capture) {
        return false
      }

      // capture not available
      if (!IS_CAPTURE_SUPPORTED) {
        return false
      }

      return true
    },

    attributes () {
      const attributes = {
        accept: this.accept,
        multiple: this.multiple,
      }

      if (this.useCapture) {
        attributes.capture = this.capture
      }

      return attributes
    },
  },

  methods: {

    init () {
      this.$el.click()
    },

    reset () {
      this.$el.value = ''
    },

    handleFile (file) {
      if (file.size > this.maxSize) {
        const error = new Error()
        error.error = ERROR_FILE_TOO_BIG
        error.size = this.size
        return Promise.reject(error)
      }

      if (this.fileTypeRegex && !this.fileTypeRegex.test(file.type)) {
        return Promise.reject(new Error({ error: ERROR_FILE_FORMAT }))
      }

      return Promise.resolve(file)
    },

    onChange (event) {
      const files = Array.from(event.target.files)

      if (!files.length) {
        this.reset()
        return this.$emit('error', new Error('no file'))
      }

      if (this.multiple) {
        if (files.length > this.maxLengthOfFiles) {
          this.$emit('error', { error: ERROR_TOO_MANY_FILES })
          this.reset()
          return
        }
        Promise.all(files.map(f => {
          return this.handleFile(f)
        }))
          .then(filesResults => {
            this.$emit('input', filesResults)
          })
          .catch(e => {
            this.$emit('error', e)
            this.reset()
          })
      } else {
        let file = files[0]
        this.handleFile(file)
          .then(() => {
            this.$emit('input', file)
          })
          .catch(e => {
            this.$emit('error', e)
            this.reset()
          })
      }
    },
  },
}
</script>
